import { render, staticRenderFns } from "./ResultsEmpathy.vue?vue&type=template&id=4f57fa2f&"
import script from "./ResultsEmpathy.vue?vue&type=script&lang=js&"
export * from "./ResultsEmpathy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports